// Chat API — separate Lambda Function URL, not the api Lambda.
// Same Cognito-token auth as the api client (Slice AUTH).
import { withAuthHeader } from "./token";

const CHAT_URL = (import.meta.env.VITE_CHAT_URL ?? "").replace(/\/$/, "");

export interface ChatMessage {
  role: "user" | "assistant";
  content: string;
  created_at?: string;
  tool_traces?: ToolTrace[] | null;
}

export interface ToolTrace {
  name: string;
  input: Record<string, unknown>;
  output_preview: string;
}

export interface ChatReply {
  reply: string;
  tool_traces: ToolTrace[];
  thread: ChatMessage[];
}

async function chatFetch(path: string, init?: RequestInit): Promise<Response> {
  if (!CHAT_URL) throw new Error("VITE_CHAT_URL not configured");
  const url = `${CHAT_URL}${path}`;
  const headers = await withAuthHeader(new Headers(init?.headers));
  if (init?.body && !headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  return fetch(url, { ...init, headers });
}

async function chatJson<T>(path: string, init?: RequestInit): Promise<T> {
  const resp = await chatFetch(path, init);
  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(`Chat ${path} → ${resp.status}: ${text}`);
  }
  return (await resp.json()) as T;
}

export async function loadChatHistory(): Promise<ChatMessage[]> {
  const data = await chatJson<{ thread: ChatMessage[] }>("/history", { method: "GET" });
  return data.thread;
}

export async function sendChat(userMessage: string): Promise<ChatReply> {
  return chatJson<ChatReply>("/", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ user_message: userMessage }),
  });
}
